<template>
    <el-col :xs="{span:24}" :md="width" v-show="show">
        <el-form-item 
            :class="className"
            :label="displayName" 
            :prop="name"
            :rules="rules">
            <input :name="fieldName" :value="data[name]" hidden="hidden">
            <el-select-v2
                class="qweelement"
                v-model="data[name]" 
                :options="userOptions"
                filterable 
                :disabled = "disabled"
                placeholder="请选择">
            </el-select-v2>
            <div class="hint"><i>{{ hint }}</i></div>
        </el-form-item>
    </el-col>
</template>


<script>
    import baseUserField from "./BaseSingleUserField"
    import { CirclePlus } from '@element-plus/icons-vue'

    export default {
        name:"SingleUserField",
        mixins:[baseUserField],
        components:{
            "circle-plus":CirclePlus
        }
    }
</script>